import React from 'react'
import SummaryIcon from '@/assets/report/sidebar/summary.svg';
import AnalysisIcon from '@/assets/report/sidebar/analysis.svg';
import CriteriaIcon from '@/assets/report/sidebar/criteria.svg';
import ResourceIcon from '@/assets/report/sidebar/resource.svg';

const IconMap: Record<string, string> = {
    'Summary': SummaryIcon,
    'Technical Analysis': AnalysisIcon,
    'Evaluation': CriteriaIcon,
    'Suggested Resources': ResourceIcon,
};

interface SidebarItemProps {
    title: string;
    anchor: string;
    isActive: boolean;
    onClick: () => void;
    'data-section-id'?: string;
}

const SidebarItem: React.FC<SidebarItemProps> = ({ 
    title, 
    anchor, 
    isActive, 
    onClick, 
    'data-section-id': dataSectionId 
}) => {
    const iconSrc = IconMap[title] || '';
    
    return (
        <button
            className={`flex flex-row select-none cursor-pointer w-full items-center gap-[10px] p-[6px_12px] self-stretch rounded-[3px] transition-colors duration-200 ${
                isActive 
                    ? 'bg-gray-100' // Active state - same as hover
                    : 'bg-white hover:bg-gray-100' // Default and hover states
            }`}
            onClick={onClick}
            data-section-id={dataSectionId}
        >
            {/* {iconSrc && <img src={iconSrc} alt={title + ' icon'} width={24} height={24} />} */}
            <span
                className="font-dm-sans font-normal"
                style={{
                    color: '#68696B',
                    fontSize: 16,
                    fontStyle: 'normal',
                    lineHeight: '24px',
                    letterSpacing: '0.08px',
                }}
            >
                {title}
            </span>
        </button>
    );
}

export default SidebarItem